import NormalizeText from "../normalizeValues/NormalizeText";

const ObtenerMoneda = ({pais, paises}) => {
  if (!pais || !paises) {
    return 0;
  }
  const paisNormalizado = NormalizeText(pais);
  const clientCountry = paises?.find((p) => NormalizeText(p.name) === paisNormalizado)
  return clientCountry?.currency || "PEN";
}

export default ObtenerMoneda;
